import { FieldsProps, FieldType } from '@crm/types'

import { getAPIDateFormat } from './date'

export const getFieldName = (key: string, lastIndex: number) =>
  lastIndex > 0 ? key.slice(0, lastIndex) : key

export const onChangeFormatForAPI = (
  storedFiltersData: Record<string, unknown>,
  dataFields?: FieldsProps
) =>
  Object.entries(storedFiltersData).reduce((acc, curVal) => {
    const [key, value]: [string, unknown] = curVal

    const lastIndex = key.lastIndexOf('__')

    const field_name = getFieldName(key, lastIndex)
    const findFieldType = dataFields?.fields.find(
      (field: FieldsProps['fields'][number]) => field.name === field_name
    )?.type

    if (
      findFieldType === FieldType.DATE ||
      findFieldType === FieldType.DATE_TIME
    ) {
      const date_val: string[] = []
      ;(Array.isArray(value) ? value : [value]).forEach((el) => {
        date_val.push(getAPIDateFormat(el))
      })

      return {
        ...acc,
        [key]: date_val
      }
    }
    return { ...acc, [key]: value }
  }, {})
